const module = 'matches'

import { checkAuth } from '@/services/auth'
import Index from '@/views/matches/Index'

var prefix = '/'

export default [
    {
        path: prefix + `${module}/open`,
        name: `${module}OpenAdmin`,
        component: Index,
        beforeEnter(to, from, next) {
            checkAuth().then(response => {
                if (response) {
                    next()
                } else {
                    next('/login')
                }
            })
        },
    },
]
